import { useConfirm } from 'components/Alert/useConfirm';
import { useMutation } from 'query';
import { undo } from 'scenes/FinancePage/FR/data/queryKeyFactory';
import { undoFR } from 'scenes/FinancePage/FR/sources';

export const useUndo = () => {
  const confirm = useConfirm();

  const approveMutation = useMutation(undo(), undoFR, {
    refresh: true,
    successMessage: () => `Financial Result undone`,
  });

  const handleAction = ({ id }: any) => {
    confirm({
      title: `Undo Financial Result ${id}?`,
      confirmActionLabel: 'Undo',
    }).then(() => approveMutation.mutateAsync({ id }));
  };

  return [handleAction, approveMutation];
};
